export enum AutomationTrigger {
  NEW_CONTACT = "new_contact",
  CONTACT = "contact",
  ON_ASSIGN_OWNER = "on_assign_owner",
}
